import { useEffect, useRef, useState } from 'react';

import { RiLink } from 'react-icons/ri';
import { DefaultPopover, Input, Button } from 'twyne-new.ui';

import { useBubbleTiptap } from '../bubble/Bubble';

import FormatterIcon from './FormatterIcon';

export default function LinkFormatter({ editor }) {
  const [open, setOpen] = useState(false)

  return <DefaultPopover
    trigger={<FormatterIcon active={editor.isActive('link')} icon={RiLink} onClick={() => setOpen(true)} tooltipText="add link" />}
    contentProps={{ side: 'bottom' }}
    wrapperProps={{ open, onOpenChange: setOpen }}
  >
    {open && <PopoverContent editor={editor} open={open} setOpen={setOpen} />}
  </DefaultPopover>
}

const PopoverContent = ({ editor, open, setOpen }) => {
  const [url, setUrl] = useState()
  const { setBubblePopover } = useBubbleTiptap()
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
    setBubblePopover && setBubblePopover(open)
  }, [open, setBubblePopover])

  useEffect(() => {
    const previousUrl = editor.getAttributes('link').href
    if (url === undefined && previousUrl) {
      setUrl(previousUrl)
    }
  }, [open, editor, url])

  const handleSetLink = () => {
    editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run()
    setOpen(false)
  }

  return <div className='flex flex-col gap-2'>
    <Input
      value={url}
      onChange={e => setUrl(e.target.value)}
      placeholder='Enter URL'
      ref={inputRef}
    />

    <div className='flex gap-2 w-full'>
      <Button block color='accent' onClick={handleSetLink} disabled={!url}>Set Link</Button>
      <Button block onClick={() => setOpen(false)}>Cancel</Button>
    </div>
  </div>
}
